import ContractIterationModel from 'Models/sales/ContractIterationModel';
import doc                    from 'decorators/doc';
import model                  from 'decorators/model';
import { Timestampable }      from 'helpers/traits';
import SalesPrivateApiModel   from 'modelx/models/abstracts/SalesPrivateApiModel';

@model.staticLabel('ContractIterationSummary')
@model.urnResource('contract_iteration_summary')
@doc.path('/contract_iteration_summaries/{?id}')
export default class ContractIterationSummaryModel extends Timestampable(SalesPrivateApiModel) {
	public _filters: ModelFiltersExtended<{
		'contractIteration': id;
	}> = {};

	public _sorts: ModelSortsExtended<unknown> = {};

	@doc.string declare consumableFeeRate: string;
	@doc.model(ContractIterationModel) declare contractIteration: ContractIterationModel;
	@doc.number declare exploitationAmount: number;
	@doc.number declare exploitationDuration: number;
	@doc.number declare gapDayPrice: number;
	@doc.number declare gapGrossMargin: number;
	@doc.number declare gapOperatingMargin: number;
	@doc.number declare gapTeamDayPrice: number;
	@doc.number declare invoicedAmount: number;
	@doc.number declare invoicedLabourAmount: number;
	@doc.number declare offerLabourPrice: number;
	@doc.number declare offerPriceExclTax: number;
	@doc.number declare orderedAmount: number;
	@doc.number declare projectedArticleCost: number;
	@doc.number declare projectedArticlePrice: number;
	@doc.number declare projectedConsumableCost: number;
	@doc.number declare projectedDayPrice: number;
	@doc.number declare projectedGrossMargin: number;
	@doc.number declare projectedLabourCost: number;
	@doc.number declare projectedLabourHours: number;
	@doc.number declare projectedOperatingMargin: number;
	@doc.number declare projectedTeamDayPrice: number;
	@doc.number declare realDayPrice: number;
	@doc.number declare realGrossMargin: number;
	@doc.number declare realOperatingMargin: number;
	@doc.number declare realTeamDayPrice: number;
	@doc.number declare unorderedAmount: number;

	// Ajouté manuellement
	@doc.number declare gapOperatingMarginRate: number;
	@doc.number declare projectedGrossMarginRate: number;
	@doc.number declare realGrossMarginRate: number;
	@doc.number declare realOperatingMarginRate: number;
	@doc.number declare projectedOperatingMarginRate: number;
}